import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { PatientFlagCriteria } from 'src/app/models/vitals/vital-flag.model';
import { FirestoreService } from 'src/app/services/firestore.service';
import { PatientService } from 'src/app/services/patient.service';

@Injectable({
  providedIn: 'root',
})
export class VitalFlagService {
  constructor(private fsService: FirestoreService, private patientService: PatientService) {}

  saveVitalFlag(vitalFlag: PatientFlagCriteria): Promise<any> {
    return this.fsService.add(`vital_flag_override`, { ...vitalFlag, patient_id: this.patientService.currentPatientServiceID });
  }

  batchSaveVitalFlags(vitalFlags: PatientFlagCriteria[]): Promise<void> {
    const batch = this.fsService.batch();
    const collectionRef = this.fsService.getDb().firestore.collection('vital_flag_override');
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    const patientId = this.patientService.currentPatientServiceID;

    for (const flag of vitalFlags) {
      const docRef = collectionRef.doc();
      batch.set(docRef, {
        ...flag,
        patient_id: patientId,
        updatedAt: timestamp,
        createdAt: timestamp,
      });
    }

    return batch.commit();
  }
}
